import { useState } from "react";
import { useGlobalContext } from "app/store/GlobalContext";

import { useRootStore } from "store";
import { Icon } from "components/icon/Icon";
import MenuDropdown, {
  MenuItem
} from "components/menu/MenuDropdown/MenuDropdown";

import "./MenuDropdown.scss";

type Props = {
  handleChangeCustomer: (customerId: string) => void;
};

export default function InternalUserCustomerMenu({
  handleChangeCustomer
}: Props) {
  const { workingCustomerId } = useRootStore((state) => state.global);
  const { unfilteredCustomers: customers } = useRootStore(
    (state) => state.customers.myCustomers
  );
  const { handleNavigation } = useGlobalContext();
  const [search, setSearch] = useState("");

  const customersItems = customers
    .filter(
      (customer) =>
        search === "" ||
        customer.customerName.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => (a.customerName > b.customerName ? 1 : -1));

  const changeCustomer = (input: string) => {
    setSearch(""); // Clear the search field
    handleChangeCustomer(input);
  };
  const menuItems: MenuItem[] = [
    {
      content: (
        <h3 title="När du klickar på Mina kunder kommer du till din startsida där dina kunder finns samlade.">
          <Icon className="dropdownMenuItemDot" name="far fa-circle-o" />
          Mina kunder
        </h3>
      ),
      hasDivider: true,
      onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        handleNavigation({
          url: "/customers",
          eventTitle: "Mina kunder",
          e: e
        });
      }
    },
    {
      content: (
        <div className="customerSearchWrapper">
          <input
            placeholder="Sök kund..."
            type="text"
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
        </div>
      ),
      hasDivider: true,
      className: "p-0",
      persistOnClick: true
    }
  ];

  const customerMenuItems: MenuItem[] = customersItems.map((customer) => ({
    content: (
      <div
        className={
          workingCustomerId === customer.customerNumber ? "fw-bold" : ""
        }
      >
        {customer.customerName}
      </div>
    ),
    onClick: () => changeCustomer(customer.customerId)
  }));

  const searchItem = {
    content:
      search !== "" && customersItems.length === 0 ? (
        <p>Inga sökresultat på "{search}".</p>
      ) : (
        ""
      )
  };

  const allMenuItems = [...menuItems, ...customerMenuItems, searchItem];

  return (
    <>
      <div className="customerDropdown">
        <MenuDropdown toggleText="Mina kunder" menuItems={allMenuItems} />
      </div>

      <div className="customerMenuFullscreen">
        <h2>Mina kunder</h2>
        <div className="customerSearchWrapper">
          <input
            placeholder="Sök kund..."
            type="text"
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul>
          {customersItems.map((c) => (
            <li key={c.customerId}>
              <span onClick={() => handleChangeCustomer(c.customerId)}>
                {c.customerName}
              </span>
            </li>
          ))}

          {search !== "" && customersItems.length === 0 && (
            <p>Inga sökresultat på "{search}".</p>
          )}
        </ul>
      </div>
    </>
  );
}
